/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChangeOrderTemplatesControllerRemoveMutationResponse, ChangeOrderTemplatesControllerRemovePathParams, ChangeOrderTemplatesControllerRemove401, ChangeOrderTemplatesControllerRemove403, ChangeOrderTemplatesControllerRemove404 } from "../../models/changeOrderTemplatesController/ChangeOrderTemplatesControllerRemove";

function getChangeOrderTemplatesControllerRemoveUrl(id: ChangeOrderTemplatesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/change-order-templates/${id}` as const }  
  return res
}

/**
 * @summary Remove the change order template link (the file stays in the project)
 * {@link /api/v1/change-order-templates/:id}
 */
export async function changeOrderTemplatesControllerRemove(id: ChangeOrderTemplatesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChangeOrderTemplatesControllerRemoveMutationResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerRemove401 | ChangeOrderTemplatesControllerRemove403 | ChangeOrderTemplatesControllerRemove404>, unknown>({ method : "DELETE", url : getChangeOrderTemplatesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}